import { render, staticRenderFns } from "./OrderCustomerServiceNote.vue?vue&type=template&id=710c95c8&"
import script from "./OrderCustomerServiceNote.vue?vue&type=script&lang=js&"
export * from "./OrderCustomerServiceNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports